export default "__VITE_ASSET__CPTpid$f__"